import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ScrollbarAutoHide.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\"],\"variable\":\"--font-inter\",\"preload\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
